// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"218":"d0dca08af43f6c93e735","589":"520553a0f7e5edf24cf5","691":"fd2d579cb04fb9b67355","774":"9e0250967ec614a2d4ef"}[chunkId] + ".js";
};